/* eslint-disable react/no-unescaped-entities */
import NextHead from '@/components/NextHead';
import metas from '@/routes/meta';
import Page from 'components/Page';
import Script from 'next/script';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

const PageWithPadding = styled(Page)`
  padding: 0 20px;
`;

const FormWrapper = styled.div`
  height: 1000px;
  margin-top: 80px;

  > iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
`;

const LanguageDropDown = styled.div`
  select {
    padding: 8px 10px;
    border-radius: 4px;
  }
`;
const Notice = styled.div`
  ul {
    list-style: none;
    padding: 0;
  }
  li {
    padding-bottom: 8px;
  }
  a {
    color: #c0ad86;
    font-family: 'Source Sans Pro', sans-serif;
    text-underline-position: under;
    font-weight: 600;
    font-size: 1.1em;
  }
`;

function Privacy() {
  const [otNoticeApiLoaded, setOtNoticeApiLoaded] = useState(false);
  const meta = metas.default;

  useEffect(() => {
    const interval = setInterval(() => {
      if (otNoticeApiLoaded) {
        clearInterval(interval);
      }
      if (typeof window.OneTrust.NoticeApi.Initialized !== 'undefined') {
        setOtNoticeApiLoaded(true);
        window.OneTrust.NoticeApi.Initialized.then(function () {
          window.OneTrust?.NoticeApi.LoadNotices(
            [
              'https://privacyportalde-cdn.onetrust.com/24527c35-1de1-4aaa-833d-de50b42446bd/privacy-notices/a58effe7-5173-4f06-a9a9-ec6180250fc1.json',
            ],
            true,
            'en-us',
          );
        });
      }
    }, 200);
    return () => clearInterval(interval);
  }, [otNoticeApiLoaded]);

  return (
    <PageWithPadding title="Privacy Policy">
      <Script
        src="https://privacyportalde-cdn.onetrust.com/privacy-notice-scripts/otnotice-1.0.min.js"
        id="otprivacy-notice-script"
      >
        settings="eyJjYWxsYmFja1VybCI6Imh0dHBzOi8vcHJpdmFjeXBvcnRhbC1kZS5vbmV0cnVzdC5jb20vcmVxdWVzdC92MS9wcml2YWN5Tm90aWNlcy9zdGF0cy92aWV3cyJ9"
      </Script>

      <NextHead meta={meta} />
      <LanguageDropDown className="otnotice-language-dropdown-container">
        <select id="otnotice-language-dropdown" aria-label="language selector"></select>
      </LanguageDropDown>
      <Notice id="otnotice-a58effe7-5173-4f06-a9a9-ec6180250fc1" className="otnotice" />
      <FormWrapper className="ot-form-wrapper">
        <iframe src="https://privacyportal-de.onetrust.com/webform/24527c35-1de1-4aaa-833d-de50b42446bd/8c650df7-a9c9-4780-a173-e91886e285fa"></iframe>
      </FormWrapper>
    </PageWithPadding>
  );
}

export default Privacy;
